"use client";
import dynamic from "next/dynamic";
import React from "react";

const TranslatorEditor = dynamic(
  () => import("@/components/tools/TranslatorEditor/TranslatorEditor"),
  { ssr: false },
);
const TranslatorCoreSection = () => {
  return (
    <div className="my-4 rounded-[8px] bg-[#FFFFFF]">
      <TranslatorEditor />
    </div>
  );
};
export default TranslatorCoreSection;
